import { Component, Mixins, Prop } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import { NumberMixin, PageHeader, Tabs, Tab, AppMessages } from '@kwixeo/interface-vue'
import { BCard, BFormRow, BCol, BFormGroup, BRow, BBadge } from 'bootstrap-vue'
import CustomPricesView from '../CustomPricesView/CustomPricesView.vue'
import CatalogPictures from '../CatalogPictures/CatalogPictures.vue'
import ServiceDelete from '../ServiceDelete/ServiceDelete.vue'
import ElementSalesList from '../ElementSalesList/ElementSalesList.vue'
import Statistics from '../Statistics/Statistics.vue'
import { CustomFieldsDisplay, CustomFieldsDisplayTab } from '@kwixeo/custom-fields-vue'

@Component({
  computed: {
    ...mapGetters('user', ['currency', 'can', 'team']),
    ...mapGetters('subscriptions', ['hasModule'])
  },
  methods: {
    ...mapActions('dynamicModals', ['openModal'])
  },
  components: {
    PageHeader, Tabs, Tab, AppMessages,
    CustomPricesView,
    CatalogPictures,
    ServiceDelete,
    ElementSalesList,
    Statistics,
    CustomFieldsDisplay, CustomFieldsDisplayTab,
    BCard, BFormRow, BCol, BFormGroup, BRow, BBadge
  }
})
export default class ServiceItem extends Mixins(NumberMixin) {
  openModal!: (params: string|KwixeoInterface.OpenModalParamObject) => void
  currency!: KwixeoFramework.Currency
  hasModule!: (key: string) => boolean
  can!: (key: string, level: number) => boolean
  team!: KwixeoFramework.Team

  @Prop({ required: true }) value!: KwixeoCatalog.Service

  private totalPictures = 0
  private toDelete = false

  get pageTitle (): string {
    return this.$t('catalog.service.itemTitle') + ' - ' + this.value.reference
  }

  get headerButtons (): KwixeoInterface.PageHeaderItems {
    const buttons: KwixeoInterface.PageHeaderItems = []

    if (this.can('catalog-services', 3)) {
      buttons.push({
        label: 'Modifier',
        click: () => {
          this.openModal({
            key: 'catalog-service-form',
            value: this.value,
            submitted: response => this.$emit('input', response.data)
          })
        }
      })
    }

    if (this.can('catalog-services', 4)) {
      buttons.push({
        label: 'Supprimer',
        click: () => {
          this.toDelete = true
        }
      })
    }

    return buttons
  }

  get nbCustomPrices (): number {
    return (this.value.custom_type_prices ? this.value.custom_type_prices.length : 0) + (this.value.custom_quantity_prices ? this.value.custom_quantity_prices.length : 0)
  }

  private updateDefaultPicture (id: number): void {
    const product = JSON.parse(JSON.stringify(this.value))
    product.default_picture_id = id
    this.$emit('input', product)
  }
}
